module.exports = __webpack_public_path__ + "c0fafa8397437c95848724aed686d63b.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/media/fonts/Poppins/Poppins-Thin.ttf
// module id = 1256
// module chunks = 0